


































































































import CreateDialog from '@/components/CreateDialog.vue'
import { CreateWholesalerTariffDTO } from '@/utils/interfaces/remittance.interface'
import Autocomplete from '@/components/Autocomplete.vue'
import { getRegions } from '@/api/Address/address'
import { Region, VueForm } from '@/utils/interfaces'
import { number } from '@/utils/validators'
import { createOrUpdateWholesalerTariff } from '@/api/Remittances/remittances.api'
import mixins from 'vue-typed-mixins'
import { editMixin } from '@/utils/mixins/editMixin'
import { crudMixin } from '@/utils/mixins/crudMixin'
import { TranslateResult } from 'vue-i18n'

export default mixins(editMixin, crudMixin).extend({
  components: {
    appCreateDialog: CreateDialog,
    appAutocomplete: Autocomplete,
  },
  props: {
    wholesaler: String,
  },
  data() {
    return {
      rules: {
        required: (v: any) => !!v || this.$t('validation.field-required'),
        number: (v: string | number) =>
          number(v.toString()) || this.$t('validation.must-be-a-number'),
        min_amount: (v: number) =>
          v < this.$data.crud.max_amount ||
          this.$t('validation.must-be-lower-than', {
            value: this.$t('max_amount'),
          }),
        max_amount: (v: number) =>
          v > this.$data.crud.min_amount ||
          this.$t('validation.must-be-greater-than', {
            value: this.$t('min_amount'),
          }),
        positive: (v: number) =>
          v >= 0 ||
          this.$t('validation.must-be-greater-than-equal', { value: 0 }),
      },
      crud: {} as CreateWholesalerTariffDTO,
      defaultCrud: {
        wholesaler: this.wholesaler,
        name: '',
        description: '',
        min_amount: 0,
        max_amount: 1,
        min_commission: 0,
        percent_commission: 0,
        is_active: true,
      },
      regions: [] as number[],
      getter: () =>
        getRegions({
          country__name: 'Cuba',
          limit: 100,
        }),
      loading: false,
    }
  },
  computed: {
    min_amount(): TranslateResult[] {
      const result = this.rules.min_amount(this.crud.min_amount)
      if (result === true) return []
      else return [result]
    },
    max_amount(): TranslateResult[] {
      const result = this.rules.max_amount(this.crud.max_amount)
      if (result === true) return []
      else return [result]
    },
  },
  methods: {
    async onSuccess() {
      const form = this.$refs.form as VueForm
      if (!form.validate()) return

      try {
        this.loading = true
        if (this.editedItem) {
          const response = await createOrUpdateWholesalerTariff({
            ...this.crud,
          })
          this.$emit('new-item', response.data)
        } else {
          const promises = this.regions.map(item => {
            const body = {
              ...this.crud,
              region: item,
            }
            return createOrUpdateWholesalerTariff(body)
          })
          const responses = await Promise.all(promises)
          responses.forEach(response => {
            this.$emit('new-item', response.data)
          })
        }
        this.$emit('input', false)
        this.resetCrud()
        form.resetValidation()
      } finally {
        this.loading = false
      }
    },
    selectAll() {
      this.regions = (this.$refs.autocomplete as any).items.map(
        (item: Region) => item.id,
      )
    },
    unselectAll() {
      this.regions = []
    },
  },
})
